import { PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYOUT_METHOD } from "../../../../Settings/routes/RoutePaymentMethods";
import { NotificationTemplate } from "../index";

const GROUP_THRESHOLD = 1;

export const PayoutMethod: NotificationTemplate<undefined> = {
  renderTitle: props => "Add payout method",
  renderBody: props => {
    return props.group.length > GROUP_THRESHOLD
      ? "Multiple clients require you to add a payout method to start receiving payments."
      : props.message;
  },
  buttonAction: (props, history) => () => {
    return history.push(PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYOUT_METHOD);
  },
  buttonText: () => "Add payout method"
};
